import Component from "../../classes/Component";

const imagesGroupSelector = '.js-group-image'
const mainImageSelector = '.js-main-image'
const imageItemsSelector = '.js-items-image'

export default function () {
    return new Component({
        name: 'images',
        requiredTargets: [imagesGroupSelector, mainImageSelector, imageItemsSelector],
        onInit() {
            console.log('init images')
        },
        onDestroy() {
            console.log('images')
        },
    })

}
